<template>
    <!-- End Marketing Popup -->
    <transition :name="$route.meta.transition || 'fade'">
        <div v-if="$route.params.id && !isDeactivated()">
            <Product :id="$route.params.id" />
        </div>
        <div v-else>
            <ProductCategories />
        </div>
    </transition>
</template>

<script>
import ProductCategories from '../views/ProductCategories.vue';
import { computed } from 'vue';

export default {
    components: {
        ProductCategories
    },
    data: () => ({
        blacklistProductGroups: ['mais', 'agrar-paket', 'zucker', 'weizen', 'kaffee', 'kakao', 'industriemetalle-paket', 'platin', 'palladium', 'uran', 'kupfer'],
        region: computed(() => window.meta?.region_configuration?.region || 'de')
    }),
    methods: {
        isDeactivated() {
            return this.blacklistProductGroups.includes(this.$route.params.id);
        }
    }
};
</script>
